import { render } from "./Tem005.vue?vue&type=template&id=94ca3e7e"
import script from "./Tem005.vue?vue&type=script&lang=js"
export * from "./Tem005.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__